import { useEffect } from "react";

import { useCommonStore, useUserStore } from "@stores/index";
import { localStorageService } from "@services/index";
import { useUserGetProfile } from "@providers/index";

export const UserInfo = () => {
  const isAuth = useCommonStore(({ isAuth }) => isAuth);
  const setCommonState = useCommonStore(({ setState }) => setState);
  const setUserState = useUserStore(({ setState }) => setState);

  const { isSuccess, data } = useUserGetProfile(isAuth);

  useEffect(() => {
    if (isSuccess && data) {
      setUserState({
        userId: data.uniqueId,
        userFullName: data.fullName,
        clientCode: data.clientCode,
        businesses: data.businesses,
        business: data.defaultBusiness,
        phone: data.phone,
        puEnabled: data.puEnabled,
        disabledFeatures: data.disabledFeatures,
        redConnectedBusinessId: data.redConnectedBusinessId || "",
      });
    }
  }, [isSuccess, data, isAuth, setUserState]);

  useEffect(() => {
    const value = localStorageService.getToken();
    if (value) {
      setCommonState({
        isStateInitiated: true,
        isAuth: true,
      });
    } else {
      setCommonState({ isStateInitiated: true });
    }
  }, [setCommonState]);

  return null;
};
